<script>
import { Line } from "vue-chartjs";
import { mapGetters } from "vuex";
import request from '@/API/';
import dayjs from "dayjs";
var utc = require("dayjs/plugin/utc"); // dependent on utc plugin
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  extends: Line,
  props: {
    a: {
      type: String,
    },
    i: {
      type: String,
    },
  },
  data: () => ({
    chartValues: null,
    labels: null,
    errorMessage: null,
    showError: null,
    options: {
      legend: {
        display: false,
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            ticks: {
              fontColor: "#2a324f",
              fontStyle: "bold",
            },
          },
        ],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Number of events',
            align: 'end',
            fontColor: "#2a324f",
            fontStyle: "bold",
          }
        }]
      },
    },
  }),
  computed: {
    ...mapGetters(["organisationDashboardDates"]),
  },
  watch: {
    organisationDashboardDates() {
      // is triggered whenever the store state changes
      this.updateChart();
    },
    i() {
      this.updateChart();
    },
    a() {
      this.updateChart();
    }
  },
  methods: {
    formatDate(timestamp) {
      return dayjs
        .tz(parseInt(timestamp) * 1000)
        .utc()
        .format("D/M/YYYY HH:mm");
    },
    formatData(data) {
      data.color = data.backgroundColor;
      data.borderColor = data.backgroundColor;
      data.backgroundColor = "rgba(255, 255, 255, 0)";
      return data;
    },
    async updateChart() {
      try {
        await request.get(
            `/data/events/interface?c=${this.$route.query.c}&f=${this.organisationDashboardDates.startDate}&t=${this.organisationDashboardDates.endDate}&q=0`
          )
          .then((response) => {
            if (!response.data[0]) {
              this.chartValues = [];
              return;
            }

            const x = response.data.filter(y => {
              const z = Object.values(y);
              return this.i == z[0].id;
            })

            if(!x[0]) {
              this.chartValues = {
                datasets: [],
                labels: [],
              };
              return;
            }
            let responseData = Object.entries(x[0])[0][1].chartdata;
            responseData.datasets = responseData.datasets.map(this.formatData);
            responseData.labels = responseData.labels.map(this.formatDate);
            this.chartValues = responseData;
          })
          .catch((err) => {
            console.log(err);
          });
        this.renderChart(this.chartValues, this.options);
      } catch (e) {
        console.error(e);
      }
    },
  },
  async created() {
    this.updateChart();
  },
};
</script>
